(function () {
  'use strict';
  if (window.__sbui) return;
  window.__sbui = true;

  var C = window.SBUI || {};
  var R = C.routes || {};
  var root = (R.root || '/');
  if (root.slice(-1) !== '/') root += '/';
  var reduce = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var Q = String.fromCharCode(34);

  function $(s, el) { return (el || document).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
  function esc(s) {
    return String(s == null ? '' : s).split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split(Q).join('&quot;').split(String.fromCharCode(39)).join('&#39;');
  }

  /* ---------- money ---------- */
  function grp(n, dec, ts, ds) {
    var s = n.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec });
    if (ts === ',') return s;
    return s.split(',').join('|').split('.').join(ds).split('|').join(ts);
  }
  function money(cents) {
    var fmt = C.moneyFormat || 'Rs. {{amount}}';
    var n = (Number(cents) || 0) / 100;
    var start = fmt.indexOf('{{');
    var end = fmt.indexOf('}}', start);
    if (start === -1 || end === -1) return grp(n, 2, ',', '.');
    var key = fmt.slice(start + 2, end).split(' ').join('');
    var val;
    if (key === 'amount_no_decimals') val = grp(n, 0, ',', '.');
    else if (key === 'amount_with_comma_separator') val = grp(n, 2, '.', ',');
    else if (key === 'amount_no_decimals_with_comma_separator') val = grp(n, 0, '.', ',');
    else val = grp(n, 2, ',', '.');
    return (fmt.slice(0, start) + val + fmt.slice(end + 2)).replace(/<[^>]*>/g, '');
  }
  function imgUrl(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ---------- fetch ---------- */
  function j(url, opts) {
    opts = opts || {};
    var h = { Accept: 'application/json' };
    if (opts.headers) for (var k in opts.headers) h[k] = opts.headers[k];
    opts.headers = h;
    opts.credentials = 'same-origin';
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok || (d && d.status && d.status >= 400)) {
          var err = new Error((d && (d.description || d.message)) || 'Something went wrong. Please try again.');
          err.data = d;
          throw err;
        }
        return d;
      });
    });
  }

  /* ---------- icons ---------- */
  var I = {
    bag: '<svg width=' + Q + '40' + Q + ' height=' + Q + '40' + Q + ' viewBox=' + Q + '0 0 24 24' + Q + ' fill=' + Q + 'none' + Q + ' stroke=' + Q + 'currentColor' + Q + ' stroke-width=' + Q + '1.3' + Q + ' aria-hidden=' + Q + 'true' + Q + '><path d=' + Q + 'M5 8h14l-1 12H6L5 8Z' + Q + '/><path d=' + Q + 'M9 8V6.5a3 3 0 0 1 6 0V8' + Q + '/></svg>',
    mark: '<svg width=' + Q + '40' + Q + ' height=' + Q + '40' + Q + ' viewBox=' + Q + '0 0 24 24' + Q + ' fill=' + Q + 'none' + Q + ' stroke=' + Q + 'currentColor' + Q + ' stroke-width=' + Q + '1.3' + Q + ' stroke-linejoin=' + Q + 'round' + Q + ' aria-hidden=' + Q + 'true' + Q + '><path d=' + Q + 'M6.5 3.5h11a1 1 0 0 1 1 1v16l-6.5-4.2-6.5 4.2v-16a1 1 0 0 1 1-1z' + Q + '/></svg>',
    bookmark: '<svg viewBox=' + Q + '0 0 24 24' + Q + ' fill=' + Q + 'none' + Q + ' stroke=' + Q + 'currentColor' + Q + ' stroke-width=' + Q + '1.7' + Q + ' stroke-linejoin=' + Q + 'round' + Q + ' aria-hidden=' + Q + 'true' + Q + '><path d=' + Q + 'M6.5 3.5h11a1 1 0 0 1 1 1v16l-6.5-4.2-6.5 4.2v-16a1 1 0 0 1 1-1z' + Q + '/></svg>',
    ruler: '<svg width=' + Q + '16' + Q + ' height=' + Q + '16' + Q + ' viewBox=' + Q + '0 0 24 24' + Q + ' fill=' + Q + 'none' + Q + ' stroke=' + Q + 'currentColor' + Q + ' stroke-width=' + Q + '1.6' + Q + ' stroke-linejoin=' + Q + 'round' + Q + ' aria-hidden=' + Q + 'true' + Q + '><rect x=' + Q + '2.5' + Q + ' y=' + Q + '8' + Q + ' width=' + Q + '19' + Q + ' height=' + Q + '8' + Q + ' rx=' + Q + '1.2' + Q + '/><path d=' + Q + 'M6.5 8v3M10.5 8v4.5M14.5 8v3M18 8v4.5' + Q + '/></svg>'
  };

  /* ---------- panels ---------- */
  var overlay = null, openPanel = null, lastFocus = null;
  var panelIds = { explore: 'sbu-explore', search: 'sbu-explore', cart: 'sbu-cart', wishlist: 'sbu-wishlist', size: 'sbu-size-guide' };

  function lock() {
    var sw = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.classList.add('sbu-locked');
    if (sw > 0) document.body.style.paddingRight = sw + 'px';
  }
  function unlock() {
    document.documentElement.classList.remove('sbu-locked');
    document.body.style.paddingRight = '';
  }
  function hidePanel(p) {
    p.classList.remove('is-open');
    p.setAttribute('aria-hidden', 'true');
  }
  function open(name) {
    var p = document.getElementById(panelIds[name] || name);
    if (!p || !overlay) return false;
    if (openPanel && openPanel !== p) hidePanel(openPanel);
    if (!openPanel) lastFocus = document.activeElement;
    openPanel = p;
    $$('dialog[open]').forEach(function (d) { try { d.close(); } catch (e) {} });
    overlay.classList.add('is-open');
    p.classList.add('is-open');
    p.setAttribute('aria-hidden', 'false');
    lock();
    if (name === 'search') selectTab('search');
    else if (name === 'explore') selectTab('explore');
    if (name === 'cart') renderCart();
    if (name === 'wishlist') renderWl();
    if (name === 'size') prepSizeGuide();
    setTimeout(function () {
      if (openPanel !== p) return;
      var f = name === 'search' ? $('[data-sbu-search-input]') : $('.sbu-close', p);
      try { (f || p).focus({ preventScroll: true }); } catch (e) {}
    }, reduce ? 0 : 80);
    return true;
  }
  function close() {
    if (!openPanel) return;
    hidePanel(openPanel);
    overlay.classList.remove('is-open');
    unlock();
    var lf = lastFocus;
    openPanel = null;
    lastFocus = null;
    if (lf && lf.focus) { try { lf.focus({ preventScroll: true }); } catch (e) {} }
  }
  window.SBUIopen = open;
  window.SBUIclose = close;

  function focusables(el) {
    return $$('a[href],button,input,select,textarea,[tabindex]', el).filter(function (n) {
      return n.tabIndex >= 0 && !n.disabled && n.offsetParent !== null && n.type !== 'hidden';
    });
  }

  document.addEventListener('keydown', function (e) {
    if (!openPanel) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(openPanel);
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || !openPanel.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* swipe to close */
  var sx = 0, sy = 0, tracking = false;
  document.addEventListener('touchstart', function (e) {
    if (!openPanel || !openPanel.contains(e.target)) { tracking = false; return; }
    if (e.target.closest && e.target.closest('.sbu-sg__scroll, input')) { tracking = false; return; }
    sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (!tracking || !openPanel) return;
    tracking = false;
    var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
    if (openPanel.id === 'sbu-size-guide') {
      var b = $('.sbu-body', openPanel);
      if (dy > 90 && Math.abs(dx) < 60 && (!b || b.scrollTop <= 0)) close();
      return;
    }
    if (Math.abs(dx) < 80 || Math.abs(dy) > 60) return;
    if (openPanel.classList.contains('sbu-drawer--right') && dx > 0) close();
    if (openPanel.classList.contains('sbu-drawer--left') && dx < 0) close();
  }, { passive: true });

  /* ---------- toast ---------- */
  var toastEl = null, toastT = 0;
  function toast(msg, act) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'sbu-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<span>' + esc(msg) + '</span>' + (act ? '<button type=' + Q + 'button' + Q + ' class=' + Q + 'sbu-toast__btn' + Q + '>' + esc(act.label) + '</button>' : '');
    if (act) $('button', toastEl).onclick = function () { toastEl.classList.remove('is-show'); act.fn(); };
    toastEl.classList.add('is-show');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-show'); }, 2800);
  }

  /* ---------- cart ---------- */
  var cart = null, newKey = null;
  function updateCount(n) {
    $$('[data-sbu-cart-count]').forEach(function (el) { el.textContent = n; });
    var t = $('[data-sbu-cart-count-text]');
    if (t) t.textContent = '(' + n + ')';
  }
  function getCart() {
    return j(root + 'cart.js').then(function (c) { cart = c; updateCount(c.item_count); if (!$('[data-sbu-pending]')) renderCart(); return c; });
  }
  function promoHtml() {
    var p = C.promo;
    if (!p || !cart) return '';
    var sub = cart.items_subtotal_price || 0;
    var left = p.threshold - sub;
    var fine = p.fine ? '<span class=' + Q + 'sbu-promo__fine' + Q + '>' + esc(p.fine) + '</span>' : '';
    if (left > 0) {
      var pct = Math.max(0.04, Math.min(1, sub / p.threshold));
      return '<div class=' + Q + 'sbu-promo' + Q + '><p>Add <b>' + money(left) + '</b> more to unlock <b>' + p.percent + '% off</b> with code <b>' + esc(p.code) + '</b></p>' + fine +
        '<div class=' + Q + 'sbu-progress' + Q + ' aria-hidden=' + Q + 'true' + Q + '><i style=' + Q + 'transform:scaleX(' + pct + ')' + Q + '></i></div></div>';
    }
    return '<div class=' + Q + 'sbu-promo is-done' + Q + '><p>You' + String.fromCharCode(8217) + 've unlocked <b>' + p.percent + '% off</b>. Use code <b>' + esc(p.code) + '</b> at checkout.</p>' + fine +
      '<button type=' + Q + 'button' + Q + ' class=' + Q + 'sbu-chip sbu-chip--sm' + Q + ' data-sbu-copy=' + Q + esc(p.code) + Q + '>Copy code</button></div>';
  }
  function lineHtml(it) {
    var opts = (it.options_with_values || []).filter(function (o) { return !(o.name === 'Title' && o.value === 'Default Title'); })
      .map(function (o) { return esc(o.name) + ': ' + esc(o.value); }).join(' · ');
    var was = it.original_line_price > it.final_line_price ? '<s class=' + Q + 'sbu-line__compare' + Q + '>' + money(it.original_line_price) + '</s>' : '';
    var img = it.image ? '<img src=' + Q + esc(imgUrl(it.image, 240)) + Q + ' alt=' + Q + esc(it.product_title) + Q + ' width=' + Q + '84' + Q + ' height=' + Q + '112' + Q + ' loading=' + Q + 'lazy' + Q + '>' : '';
    return '<div class=' + Q + 'sbu-line' + (it.key === newKey ? ' is-new' : '') + Q + ' data-key=' + Q + esc(it.key) + Q + '>' +
      '<a class=' + Q + 'sbu-line__img' + Q + ' href=' + Q + esc(it.url) + Q + ' tabindex=' + Q + '-1' + Q + '>' + img + '</a>' +
      '<div class=' + Q + 'sbu-line__main' + Q + '><div class=' + Q + 'sbu-line__top' + Q + '><div><a class=' + Q + 'sbu-line__name' + Q + ' href=' + Q + esc(it.url) + Q + '>' + esc(it.product_title) + '</a>' +
      (opts ? '<p class=' + Q + 'sbu-line__opts' + Q + '>' + opts + '</p>' : '') + '</div>' +
      '<p class=' + Q + 'sbu-line__price' + Q + '>' + money(it.final_line_price) + was + '</p></div>' +
      '<div class=' + Q + 'sbu-line__bottom' + Q + '><div class=' + Q + 'sbu-qty' + Q + '>' +
      '<button type=' + Q + 'button' + Q + ' data-sbu-qty=' + Q + '-1' + Q + ' aria-label=' + Q + 'Decrease quantity of ' + esc(it.product_title) + Q + '>' + String.fromCharCode(8722) + '</button>' +
      '<span>' + it.quantity + '</span>' +
      '<button type=' + Q + 'button' + Q + ' data-sbu-qty=' + Q + '1' + Q + ' aria-label=' + Q + 'Increase quantity of ' + esc(it.product_title) + Q + '>+</button></div>' +
      '<button type=' + Q + 'button' + Q + ' class=' + Q + 'sbu-remove' + Q + ' data-sbu-remove>Remove</button></div></div></div>';
  }
  function renderCart() {
    var body = $('[data-sbu-cart-body]'), foot = $('[data-sbu-cart-foot]');
    if (!body) return;
    if (!cart) {
      body.innerHTML = '<div class=' + Q + 'sbu-skel' + Q + '></div><div class=' + Q + 'sbu-skel' + Q + '></div>';
      foot.hidden = true;
      getCart();
      return;
    }
    if (!cart.item_count) {
      body.innerHTML = '<div class=' + Q + 'sbu-empty' + Q + '>' + I.bag + '<p>Your bag is empty</p><a class=' + Q + 'sbu-btn sbu-btn--auto' + Q + ' href=' + Q + esc(R.allProducts || '/collections/all') + Q + '>Start shopping</a></div>';
      foot.hidden = true;
      return;
    }
    body.innerHTML = promoHtml() + cart.items.map(lineHtml).join('');
    var savings = cart.total_discount > 0 ? '<div class=' + Q + 'sbu-row sbu-row--muted' + Q + '><span>Savings</span><span>' + String.fromCharCode(8722) + ' ' + money(cart.total_discount) + '</span></div>' : '';
    foot.innerHTML = savings +
      '<div class=' + Q + 'sbu-row' + Q + '><span>Subtotal</span><strong>' + money(cart.total_price) + '</strong></div>' +
      '<p class=' + Q + 'sbu-note' + Q + '>Discount codes and shipping are applied at checkout. Free shipping on prepaid orders.</p>' +
      '<form action=' + Q + esc(R.cart || '/cart') + Q + ' method=' + Q + 'post' + Q + '><button class=' + Q + 'sbu-btn' + Q + ' type=' + Q + 'submit' + Q + ' name=' + Q + 'checkout' + Q + '>Checkout</button></form>' +
      '<a class=' + Q + 'sbu-textlink' + Q + ' href=' + Q + esc(R.cart || '/cart') + Q + '>View full bag</a>';
    foot.hidden = false;
    newKey = null;
  }
  function changeLine(el, key, qty) {
    el.classList.add('is-busy');
    j(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (c) {
        cart = c;
        updateCount(c.item_count);
        if (qty === 0 && !reduce) { el.classList.add('is-leaving'); setTimeout(renderCart, 240); }
        else renderCart();
      })
      .catch(function (err) { el.classList.remove('is-busy'); toast(err.message); });
  }

  /* ---------- add to cart ---------- */
  var busyForms = [];
  function setLoading(btn, on) {
    [btn, $('.sticky-add-to-cart__button')].forEach(function (b) {
      if (!b) return;
      b.classList.toggle('sbu-loading', on);
      if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
    });
  }
  /* Optimistic add: open the bag at once with the item shown, confirm with the store in the background. */
  function pendingInfo(form, btn) {
    if (!form) return { title: '', opts: '', price: null, img: '' };
    var card = form.closest('.sb-card');
    if (card) {
      var ct = $('.sb-card__title', card), ci = $('.sb-card__media img', card);
      var ot = btn && btn.textContent ? btn.textContent.trim() : '';
      return { title: ct ? ct.textContent.trim() : '', opts: ot && ot !== 'Add' ? ot : '', price: null, img: ci ? (ci.currentSrc || ci.src || '') : '' };
    }
    var scope = form ? (form.closest('dialog, quick-add-dialog, .shopify-section') || document) : document;
    var id = form ? new FormData(form).get('id') : null;
    var v = null;
    $$('variant-picker script[type=' + Q + 'application/json' + Q + ']', scope).some(function (sc) {
      try { var d = JSON.parse(sc.textContent); if (d && String(d.id) === String(id)) { v = d; return true; } } catch (e) {}
      return false;
    });
    var h = $('h1', scope) || $('h2', scope);
    var title = h ? h.textContent.trim() : (v && v.name ? v.name : '');
    var img = v && v.featured_image && v.featured_image.src ? v.featured_image.src : '';
    if (!img) { var im = $('.product-media img, media-gallery img, .product-information__media img', scope); if (im) img = im.currentSrc || im.src || ''; }
    return { title: title, opts: v && v.title && v.title !== 'Default Title' ? v.title : '', price: v ? v.price : null, img: img };
  }
  function pendingHtml(info) {
    var img = info.img ? '<img src=' + Q + esc(imgUrl(info.img, 240)) + Q + ' alt=' + Q + Q + ' width=' + Q + '84' + Q + ' height=' + Q + '112' + Q + '>' : '';
    return '<div class=' + Q + 'sbu-line is-new is-pending' + Q + ' data-sbu-pending>' +
      '<span class=' + Q + 'sbu-line__img' + Q + '>' + img + '</span>' +
      '<div class=' + Q + 'sbu-line__main' + Q + '><div class=' + Q + 'sbu-line__top' + Q + '><div><span class=' + Q + 'sbu-line__name' + Q + '>' + esc(info.title || 'Adding to bag') + '</span>' +
      (info.opts ? '<p class=' + Q + 'sbu-line__opts' + Q + '>' + esc(info.opts) + '</p>' : '') + '</div>' +
      (info.price != null ? '<p class=' + Q + 'sbu-line__price' + Q + '>' + money(info.price) + '</p>' : '') + '</div>' +
      '<p class=' + Q + 'sbu-pending-note' + Q + '>Adding to your bag' + String.fromCharCode(8230) + '</p></div></div>';
  }
  function showPending(form, btn) {
    open('cart');
    var body = $('[data-sbu-cart-body]');
    if (!body) return;
    if (cart && cart.item_count) renderCart(); else body.innerHTML = '';
    var old = $('[data-sbu-pending]', body); if (old) old.remove();
    var promo = $('.sbu-promo', body);
    var html = pendingHtml(pendingInfo(form, btn));
    if (promo) promo.insertAdjacentHTML('afterend', html); else body.insertAdjacentHTML('afterbegin', html);
    body.scrollTop = 0;
  }
  function mergeAdded(res) {
    if (!cart || !res) return false;
    var list = res.items ? res.items : [res];
    list.forEach(function (it) {
      var idx = -1;
      cart.items.forEach(function (x, i) { if (x.key === it.key) idx = i; });
      var prevQty = idx > -1 ? cart.items[idx].quantity : 0;
      var prevLine = idx > -1 ? cart.items[idx].final_line_price : 0;
      if (idx > -1) cart.items.splice(idx, 1);
      cart.items.unshift(it);
      cart.item_count += it.quantity - prevQty;
      var diff = (it.final_line_price || 0) - prevLine;
      cart.total_price += diff;
      cart.items_subtotal_price = (cart.items_subtotal_price || 0) + diff;
    });
    return true;
  }
  function addVariant(payload, btn, form) {
    setLoading(btn, true);
    showPending(form, btn);
    return j(root + 'cart/add.js', payload)
      .then(function (res) {
        var added = res && res.items ? res.items[0] : res;
        var nk = added && added.key;
        if (mergeAdded(res)) { updateCount(cart.item_count); newKey = nk; renderCart(); }
        setLoading(btn, false);
        if (btn) { btn.classList.add('sbu-added'); setTimeout(function () { btn.classList.remove('sbu-added'); }, 1400); }
        return j(root + 'cart.js').then(function (c) {
          var hadNew = !!$('[data-sbu-pending]');
          cart = c; updateCount(c.item_count);
          if (hadNew) newKey = nk;
          renderCart();
        });
      })
      .catch(function (err) {
        var pend = $('[data-sbu-pending]'); if (pend) pend.remove();
        if (cart) renderCart();
        toast(err.message || 'Could not add to bag');
        throw err;
      })
      .finally(function () { setLoading(btn, false); });
  }
  /* Load the bag in the background so the drawer can show it instantly on the first add. */
  setTimeout(function () {
    if (cart) return;
    j(root + 'cart.js').then(function (c) { if (!cart) { cart = c; updateCount(c.item_count); } }).catch(function () {});
  }, 1200);
  function isAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return false;
    return !form.closest('[data-sbu-native]');
  }
  function handleAdd(form, btn) {
    if (busyForms.indexOf(form) > -1) return;
    if (!sizeOk(form)) return;
    var fd = new FormData(form);
    if (btn && btn.name && btn.value && !fd.get(btn.name)) fd.append(btn.name, btn.value);
    if (!fd.get('id')) { toast('Please choose an option'); return; }
    var qa = form.closest('details.sb-qa'); if (qa) qa.open = false;
    busyForms.push(form);
    addVariant({ method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: fd }, btn, form)
      .catch(function () {})
      .finally(function () { busyForms.splice(busyForms.indexOf(form), 1); });
  }
  /* Horizon adds to cart from its own click handler, so intercept the click first (window capture runs before it). */
  window.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t && t.closest && t.closest('button[type=submit], .add-to-cart-button');
    if (!btn) return;
    var form;
    if (btn.closest('sticky-add-to-cart')) {
      var sec = btn.closest('.shopify-section') || document;
      form = $('product-form-component form', sec) || $('product-form-component form');
    } else {
      form = btn.form || btn.closest('form');
    }
    if (!isAddForm(form)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    handleAdd(form, btn);
  }, true);
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isAddForm(form)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    handleAdd(form, e.submitter || $('[type=submit]', form));
  }, true);

  /* ---------- size selection ---------- */
  var sizePicked = location.search.indexOf('variant=') > -1;
  function mainPicker() { return $('variant-picker[data-template-product-match]'); }
  function sizeFieldset(picker) {
    if (!picker) return null;
    return $$('fieldset', picker).filter(function (f) {
      var lg = $('legend', f);
      return lg && lg.textContent.toLowerCase().indexOf('size') > -1;
    })[0] || null;
  }
  function sizeOk(form) {
    var picker = $('variant-picker[data-sb-unpicked]');
    if (!picker) return true;
    var pf = form.closest('product-form-component');
    if (pf && pf.dataset.productId && picker.dataset.productId && pf.dataset.productId !== picker.dataset.productId) return true;
    if (form.closest('quick-add-dialog, dialog')) return true;
    var fs = sizeFieldset(picker);
    if (!fs) return true;
    if (fs.getBoundingClientRect().top < 80 || fs.getBoundingClientRect().bottom > window.innerHeight) {
      fs.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    }
    fs.classList.remove('sbu-shake');
    void fs.offsetWidth;
    fs.classList.add('sbu-shake');
    var msg = $('.sbu-size-msg', fs);
    if (!msg) { msg = document.createElement('p'); msg.className = 'sbu-size-msg'; msg.setAttribute('role', 'alert'); fs.appendChild(msg); }
    msg.textContent = 'Please select a size';
    return false;
  }
  function markPicked() {
    sizePicked = true;
    $$('variant-picker[data-sb-unpicked]').forEach(function (p) { p.removeAttribute('data-sb-unpicked'); });
    $$('.sbu-size-msg').forEach(function (m) { m.remove(); });
  }
  function onPick(e) {
    var t = e.target;
    if (t && t.closest && t.closest('fieldset[data-sb-size]')) markPicked();
  }
  document.addEventListener('click', onPick, true);
  document.addEventListener('change', onPick, true);

  function ensureSize() {
    var picker = mainPicker();
    if (!picker) return;
    var fs = sizeFieldset(picker);
    if (!fs) return;
    if (!fs.hasAttribute('data-sb-size')) fs.setAttribute('data-sb-size', '');
    var lg = $('legend', fs);
    if (document.getElementById('sbu-size-guide') && lg && !$('.sbu-sg-trigger', lg)) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sbu-sg-trigger';
      b.setAttribute('data-sbu-open', 'size');
      b.setAttribute('aria-haspopup', 'dialog');
      b.setAttribute('aria-controls', 'sbu-size-guide');
      b.innerHTML = I.ruler + '<span>Size guide</span>';
      lg.appendChild(b);
    }
    var radios = $$('input[type=radio]', fs);
    if (!sizePicked && radios.length > 1 && !picker.hasAttribute('data-sb-unpicked')) picker.setAttribute('data-sb-unpicked', '');
    var sv = $('.sticky-add-to-cart__variant');
    if (sv && !sizePicked && radios.length > 1 && sv.textContent.trim() !== 'Select a size') sv.textContent = 'Select a size';
  }

  /* ---------- size guide ---------- */
  var sgReady = false;
  function parseNum(t) {
    t = (t || '').trim();
    if (!t) return null;
    var parts = t.split('-').map(function (s) { return s.trim(); });
    if (parts.length > 2) return null;
    for (var i = 0; i < parts.length; i++) if (parts[i] === '' || isNaN(Number(parts[i]))) return null;
    return parts.map(Number);
  }
  function sizeValues() {
    var fs = sizeFieldset(mainPicker());
    return fs ? $$('input[type=radio]', fs).map(function (r) { return String(r.value).trim().toUpperCase(); }) : [];
  }
  function prepSizeGuide() {
    var box = $('[data-sbu-sg-content]');
    if (!box) return;
    var sizes = sizeValues();
    if (!sgReady) {
      sgReady = true;
      $$('table', box).forEach(function (tb) {
        if (!tb.parentElement.classList.contains('sbu-sg__scroll')) {
          var w = document.createElement('div');
          w.className = 'sbu-sg__scroll';
          tb.parentNode.insertBefore(w, tb);
          w.appendChild(tb);
        }
        var rows = $$('tr', tb), head = null, best = 0;
        rows.forEach(function (r) {
          var hits = $$('td,th', r).filter(function (c) { return sizes.indexOf(c.textContent.trim().toUpperCase()) > -1; }).length;
          if (hits > best) { best = hits; head = r; }
        });
        if (!head) head = rows[0];
        if (head) head.classList.add('sbu-sg__head');
        var past = false;
        rows.forEach(function (r) {
          if (r === head) { past = true; return; }
          if (!past) return;
          $$('td,th', r).forEach(function (c, i) {
            if (i === 0) return;
            var n = parseNum(c.textContent);
            if (n) { c.setAttribute('data-in', c.textContent.trim()); c.setAttribute('data-cm', n.map(function (v) { return String(Math.round(v * 2.54 * 10) / 10); }).join(' - ')); }
          });
        });
      });
    }
    var fs = sizeFieldset(mainPicker());
    var chk = fs ? $('input[type=radio]:checked', fs) : null;
    var sel = sizePicked && chk ? String(chk.value).trim().toUpperCase() : '';
    $$('.is-col', box).forEach(function (c) { c.classList.remove('is-col'); });
    var info = $('[data-sbu-sg-sel]');
    if (info) info.innerHTML = sel ? 'Your selection: <b>' + esc(sel) + '</b>' : 'Select a size to highlight it';
    if (!sel) return;
    $$('table', box).forEach(function (tb) {
      var head = $('.sbu-sg__head', tb);
      if (!head) return;
      var idx = -1;
      $$('td,th', head).forEach(function (c, i) { if (c.textContent.trim().toUpperCase() === sel) idx = i; });
      if (idx < 1) return;
      $$('tr', tb).forEach(function (r) { var c = r.children[idx]; if (c) c.classList.add('is-col'); });
    });
  }
  function setUnit(u) {
    $$('[data-sbu-unit]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-sbu-unit') === u)); });
    $$('[data-in]').forEach(function (c) { c.textContent = u === 'cm' ? c.getAttribute('data-cm') : c.getAttribute('data-in'); });
    var n = $('[data-sbu-sg-unitnote]');
    if (n) n.textContent = u === 'cm' ? 'Values converted to centimetres (1 in = 2.54 cm).' : 'Values shown in inches, as listed on our size chart.';
  }

  /* ---------- search ---------- */
  var sCtrl = null, sTimer = 0;
  function selectTab(name) {
    $$('[role=tab][data-sbu-tab]').forEach(function (t) {
      var on = t.getAttribute('data-sbu-tab') === name;
      t.setAttribute('aria-selected', String(on));
      t.tabIndex = on ? 0 : -1;
    });
    var pe = $('#sbu-pane-explore'), ps = $('#sbu-pane-search');
    if (pe) pe.classList.toggle('is-active', name === 'explore');
    if (ps) ps.classList.toggle('is-active', name === 'search');
    if (name === 'search') setTimeout(function () { var i = $('[data-sbu-search-input]'); if (i) try { i.focus({ preventScroll: true }); } catch (e) {} }, reduce ? 0 : 140);
  }
  function hl(title, q) {
    var i = title.toLowerCase().indexOf(q.toLowerCase());
    if (i < 0 || !q) return esc(title);
    return esc(title.slice(0, i)) + '<mark>' + esc(title.slice(i, i + q.length)) + '</mark>' + esc(title.slice(i + q.length));
  }
  function doSearch(q) {
    var res = $('[data-sbu-search-results]'), idle = $('[data-sbu-search-idle]'), form = $('[data-sbu-search-form]');
    if (sCtrl) sCtrl.abort();
    if (form) form.classList.toggle('has-value', !!q);
    if (!q) { res.innerHTML = ''; idle.hidden = false; return; }
    idle.hidden = true;
    res.innerHTML = '<div class=' + Q + 'sbu-skel sbu-skel--sm' + Q + '></div><div class=' + Q + 'sbu-skel sbu-skel--sm' + Q + '></div><div class=' + Q + 'sbu-skel sbu-skel--sm' + Q + '></div>';
    sCtrl = window.AbortController ? new AbortController() : null;
    var url = (R.predictive || '/search/suggest') + '.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, { signal: sCtrl ? sCtrl.signal : undefined, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var r = (d && d.resources && d.resources.results) || {};
        var prods = r.products || [], cols = r.collections || [];
        var all = '<a class=' + Q + 'sbu-all' + Q + ' href=' + Q + esc((R.search || '/search') + '?q=' + encodeURIComponent(q) + '&type=product') + Q + '>View all results for ' + String.fromCharCode(8220) + esc(q) + String.fromCharCode(8221) + '</a>';
        if (!prods.length && !cols.length) {
          res.innerHTML = '<p class=' + Q + 'sbu-msg' + Q + '>No matches for ' + String.fromCharCode(8220) + esc(q) + String.fromCharCode(8221) + '. Try ' + String.fromCharCode(8220) + 'kurti' + String.fromCharCode(8221) + ' or ' + String.fromCharCode(8220) + 'co-ord' + String.fromCharCode(8221) + '.</p>';
          return;
        }
        var html = '';
        if (prods.length) {
          html += '<p class=' + Q + 'sbu-label' + Q + '>Products</p>' + prods.map(function (p) {
            var price = Math.round(parseFloat(p.price || 0) * 100);
            var cmp = Math.round(parseFloat(p.compare_at_price_max || 0) * 100);
            var im = p.image || (p.featured_image && p.featured_image.url) || '';
            return '<a class=' + Q + 'sbu-prod' + Q + ' href=' + Q + esc(p.url) + Q + '>' +
              (im ? '<img src=' + Q + esc(imgUrl(im, 160)) + Q + ' alt=' + Q + Q + ' width=' + Q + '56' + Q + ' height=' + Q + '70' + Q + ' loading=' + Q + 'lazy' + Q + '>' : '<span class=' + Q + 'sbu-prod__ph' + Q + '></span>') +
              '<span><span class=' + Q + 'sbu-prod__t' + Q + '>' + hl(p.title || '', q) + '</span><span class=' + Q + 'sbu-prod__p' + Q + '>' + money(price) + (cmp > price ? '<s>' + money(cmp) + '</s>' : '') + (p.available === false ? ' <em>Sold out</em>' : '') + '</span></span></a>';
          }).join('');
        }
        if (cols.length) {
          html += '<p class=' + Q + 'sbu-label' + Q + '>Collections</p><div class=' + Q + 'sbu-chips' + Q + '>' + cols.map(function (c) {
            return '<a class=' + Q + 'sbu-chip' + Q + ' href=' + Q + esc(c.url) + Q + '>' + esc(c.title) + '</a>';
          }).join('') + '</div>';
        }
        res.innerHTML = html + all;
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        res.innerHTML = '<p class=' + Q + 'sbu-msg' + Q + '>Search is unavailable right now. Press Enter to see all results.</p>';
      });
  }

  /* ---------- wishlist ---------- */
  var WKEY = 'sb-wishlist-v1', pcache = {};
  function wlGet() { try { var a = JSON.parse(localStorage.getItem(WKEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function wlSet(a) { try { localStorage.setItem(WKEY, JSON.stringify(a)); } catch (e) {} wlSync(); }
  function wlToggle(h) {
    var a = wlGet(), i = a.indexOf(h);
    if (i > -1) a.splice(i, 1); else a.unshift(h);
    wlSet(a);
    return i === -1;
  }
  function wlSync() {
    var a = wlGet();
    $$('[data-sbu-save]').forEach(function (b) {
      var on = a.indexOf(b.getAttribute('data-sbu-save')) > -1;
      b.setAttribute('aria-pressed', String(on));
      b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Save to wishlist');
    });
    $$('[data-sbu-wl-count]').forEach(function (el) { el.textContent = a.length; });
    $$('[data-sbu-wl-badge]').forEach(function (el) { el.hidden = !a.length; el.textContent = a.length; });
    var t = $('[data-sbu-wl-count-text]');
    if (t) t.textContent = '(' + a.length + ')';
  }
  function prod(h) {
    if (pcache[h]) return Promise.resolve(pcache[h]);
    return j(root + 'products/' + encodeURIComponent(h) + '.js').then(function (p) { pcache[h] = p; return p; }).catch(function () { return null; });
  }
  function wlItem(p) {
    var single = p.variants.length === 1;
    var price = money(p.price);
    var was = p.compare_at_price > p.price ? '<s class=' + Q + 'sbu-line__compare' + Q + '>' + money(p.compare_at_price) + '</s>' : '';
    var im = p.featured_image ? '<img src=' + Q + esc(imgUrl(p.featured_image, 240)) + Q + ' alt=' + Q + esc(p.title) + Q + ' width=' + Q + '84' + Q + ' height=' + Q + '112' + Q + ' loading=' + Q + 'lazy' + Q + '>' : '';
    var chips = single ? '' : '<div class=' + Q + 'sbu-sizes' + Q + ' role=' + Q + 'group' + Q + ' aria-label=' + Q + 'Choose size for ' + esc(p.title) + Q + '>' + p.variants.map(function (v) {
      return '<button type=' + Q + 'button' + Q + ' class=' + Q + 'sbu-size' + Q + ' data-variant=' + Q + v.id + Q + ' aria-pressed=' + Q + 'false' + Q + (v.available ? '' : ' disabled') + '>' + esc(v.title) + '</button>';
    }).join('') + '</div>';
    var buy = p.available
      ? chips + '<button type=' + Q + 'button' + Q + ' class=' + Q + 'sbu-btn sbu-btn--mini' + Q + ' data-sbu-wl-add' + (single ? ' data-variant=' + Q + p.variants[0].id + Q : '') + '>Add to bag</button><p class=' + Q + 'sbu-hint' + Q + ' data-sbu-wl-hint></p>'
      : '<p class=' + Q + 'sbu-line__opts' + Q + '>Sold out</p>';
    return '<div class=' + Q + 'sbu-line sbu-wl' + Q + ' data-handle=' + Q + esc(p.handle) + Q + '>' +
      '<a class=' + Q + 'sbu-line__img' + Q + ' href=' + Q + esc(p.url) + Q + ' tabindex=' + Q + '-1' + Q + '>' + im + '</a>' +
      '<div class=' + Q + 'sbu-line__main' + Q + '><div class=' + Q + 'sbu-line__top' + Q + '><a class=' + Q + 'sbu-line__name' + Q + ' href=' + Q + esc(p.url) + Q + '>' + esc(p.title) + '</a>' +
      '<p class=' + Q + 'sbu-line__price' + Q + '>' + price + was + '</p></div>' + buy +
      '<button type=' + Q + 'button' + Q + ' class=' + Q + 'sbu-remove' + Q + ' data-sbu-wl-remove>Remove</button></div></div>';
  }
  function renderWl() {
    var body = $('[data-sbu-wl-body]');
    if (!body) return;
    var a = wlGet();
    if (!a.length) {
      body.innerHTML = '<div class=' + Q + 'sbu-empty' + Q + '>' + I.mark + '<p>Nothing saved yet.<br>Tap the bookmark on any style to keep it here.</p><button type=' + Q + 'button' + Q + ' class=' + Q + 'sbu-btn sbu-btn--auto' + Q + ' data-sbu-open=' + Q + 'explore' + Q + '>Explore styles</button></div>';
      return;
    }
    if (!body.children.length || !$('.sbu-wl', body)) body.innerHTML = a.map(function () { return '<div class=' + Q + 'sbu-skel' + Q + '></div>'; }).join('');
    Promise.all(a.map(prod)).then(function (list) {
      var html = list.map(function (p) { return p ? wlItem(p) : ''; }).join('');
      body.innerHTML = html || '<div class=' + Q + 'sbu-empty' + Q + '><p>These items are no longer available.</p></div>';
    });
  }

  /* ---------- product cards ---------- */
  var decoTimer = 0;
  function decorate() {
    $$('product-card').forEach(function (card) {
      if (card.closest('.sbu-drawer') || $('[data-sbu-save]', card)) return;
      var a = $('a[href*=products]', card);
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var h = (href.split('/products/')[1] || '').split('?')[0].split('#')[0].split('/')[0];
      if (!h) return;
      var g = $('.card-gallery', card) || card;
      if (getComputedStyle(g).position === 'static') g.style.position = 'relative';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sbu-save sbu-save--card';
      b.setAttribute('data-sbu-save', h);
      b.setAttribute('aria-pressed', 'false');
      b.setAttribute('aria-label', 'Save to wishlist');
      b.innerHTML = I.bookmark;
      g.appendChild(b);
    });
    wlSync();
  }

  /* ---------- clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var o = t.closest('[data-sbu-open]');
    if (o) {
      var name = o.getAttribute('data-sbu-open');
      if (document.getElementById(panelIds[name] || '')) { e.preventDefault(); open(name); return; }
    }
    if (t.closest('[data-sbu-close]')) { e.preventDefault(); close(); return; }

    var tab = t.closest('[data-sbu-tab]');
    if (tab) { e.preventDefault(); selectTab(tab.getAttribute('data-sbu-tab')); return; }

    var sv = t.closest('[data-sbu-save]');
    if (sv) {
      e.preventDefault();
      e.stopPropagation();
      var on = wlToggle(sv.getAttribute('data-sbu-save'));
      $$('[data-sbu-save=' + Q + sv.getAttribute('data-sbu-save') + Q + ']').forEach(function (b) {
        b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop');
      });
      toast(on ? 'Saved to your wishlist' : 'Removed from wishlist', on ? { label: 'View', fn: function () { open('wishlist'); } } : null);
      return;
    }

    var cp = t.closest('[data-sbu-copy]');
    if (cp) {
      var code = cp.getAttribute('data-sbu-copy');
      var done = function () { toast('Code ' + code + ' copied'); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done); else done();
      return;
    }

    var qb = t.closest('[data-sbu-qty]'), rm = t.closest('[data-sbu-remove]');
    if ((qb || rm) && cart) {
      var line = t.closest('.sbu-line');
      var key = line && line.getAttribute('data-key');
      var item = cart.items.filter(function (i) { return i.key === key; })[0];
      if (!item) return;
      changeLine(line, key, rm ? 0 : Math.max(0, item.quantity + parseInt(qb.getAttribute('data-sbu-qty'), 10)));
      return;
    }

    var chip = t.closest('.sbu-size');
    if (chip) {
      var wrap = chip.closest('.sbu-line');
      $$('.sbu-size', wrap).forEach(function (c) { c.setAttribute('aria-pressed', String(c === chip)); });
      var addb = $('[data-sbu-wl-add]', wrap);
      if (addb) addb.setAttribute('data-variant', chip.getAttribute('data-variant'));
      var hint = $('[data-sbu-wl-hint]', wrap);
      if (hint) hint.textContent = '';
      return;
    }
    var wa = t.closest('[data-sbu-wl-add]');
    if (wa) {
      var vid = wa.getAttribute('data-variant');
      var wl = wa.closest('.sbu-line');
      if (!vid) {
        var hi = $('[data-sbu-wl-hint]', wl);
        if (hi) hi.textContent = 'Select a size first';
        var sz = $('.sbu-sizes', wl);
        if (sz) { sz.classList.remove('sbu-shake'); void sz.offsetWidth; sz.classList.add('sbu-shake'); }
        return;
      }
      if (wa.classList.contains('sbu-loading')) return;
      addVariant({ method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] }) }, wa).catch(function () {});
      return;
    }
    var wr = t.closest('[data-sbu-wl-remove]');
    if (wr) {
      var row = wr.closest('.sbu-line');
      var hd = row && row.getAttribute('data-handle');
      if (!hd) return;
      row.classList.add('is-leaving');
      setTimeout(function () { var a = wlGet(); var i = a.indexOf(hd); if (i > -1) { a.splice(i, 1); wlSet(a); } renderWl(); }, reduce ? 0 : 240);
      return;
    }
    var un = t.closest('[data-sbu-unit]');
    if (un) { setUnit(un.getAttribute('data-sbu-unit')); return; }
  });

  /* ---------- init ---------- */
  function init() {
    overlay = $('[data-sbu-overlay]');
    ['[data-sbu-overlay]', '#sbu-explore', '#sbu-cart', '#sbu-wishlist', '#sbu-size-guide'].forEach(function (s) {
      var el = $(s);
      if (el && el.parentElement !== document.body) document.body.appendChild(el);
    });
    if (overlay) overlay.addEventListener('click', close);

    var input = $('[data-sbu-search-input]');
    if (input) {
      input.addEventListener('input', function () {
        clearTimeout(sTimer);
        var q = input.value.trim();
        sTimer = setTimeout(function () { doSearch(q); }, 220);
      });
      var clr = $('[data-sbu-search-clear]');
      if (clr) clr.addEventListener('click', function () { input.value = ''; doSearch(''); input.focus(); });
    }
    window.addEventListener('storage', function (e) { if (e.key === WKEY) wlSync(); });

    wlSync();
    decorate();
    ensureSize();

    var mo = new MutationObserver(function () {
      clearTimeout(decoTimer);
      decoTimer = setTimeout(function () { decorate(); ensureSize(); }, 60);
    });
    mo.observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* ---------- card image dots ---------- */
  function setDot(g, i) {
    var dots = $$('.sb-card-dots > span', g);
    if (!dots.length) return;
    if (i > dots.length - 1) i = dots.length - 1;
    if (i < 0) i = 0;
    dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
  }
  var dotRaf = 0;
  document.addEventListener('scroll', function (e) {
    var sc = e.target;
    if (!sc || !sc.tagName || sc.tagName !== 'SLIDESHOW-SLIDES') return;
    var g = sc.closest('.card-gallery');
    if (!g || !$('.sb-card-dots', g)) return;
    if (dotRaf) cancelAnimationFrame(dotRaf);
    dotRaf = requestAnimationFrame(function () { setDot(g, Math.round(Math.abs(sc.scrollLeft) / (sc.clientWidth || 1))); });
  }, true);
  document.addEventListener('slideshow:select', function (e) {
    var g = e.target && e.target.closest && e.target.closest('.card-gallery');
    if (g && e.detail && typeof e.detail.index === 'number') setDot(g, e.detail.index);
  }, true);
})();
